<template>
  <div :class="$style.root">
    <UiIcon
      :class="$style.icon"
      :color-inheritance="true"
      name="star"
    />
    <span :class="$style.value">{{ value }}</span>
  </div>
</template>

<script>
  import UiIcon from '@/components/UiIcon';

  export default {
    name: 'IconValueStar',
    components: {
      UiIcon,
    },
    props: {
      value: {
        type: [Number, String],
        default: null,
      },
    },
  };
</script>

<style lang="scss" module>
  .root {
    position: relative;
  }

  .icon {
    font-size: 28px;
    color: $colorWarning;
  }

  .value {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: 600;
    color: $colorBlack;
    position: absolute;
    top: 3px;
    right: 0;
    bottom: 0;
    left: 0;
  }
</style>
